import { Injectable, OnInit } from '@angular/core';

import { RecordOtherDataResponse } from 'store/models/record.models';

@Injectable()
export abstract class CustomersBase implements OnInit {

  constructor(
  ) {
  }

  ngOnInit() {
  }

  /**
   * Check whether this customer has valid other data
   * @method hasValidOtherData
   */
  hasValidOtherData(otherData: RecordOtherDataResponse): boolean {
    if (otherData && otherData.results.length && otherData.results[0].data.surveys) {
      try {
        JSON.parse(otherData.results[0].data.surveys);
      } catch (e) {
        return false;
      }

      if (Object.keys(JSON.parse(otherData.results[0].data.surveys)).length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
